import React from 'react';
import '../style/home.css';
import { FaIdCard } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import EditPcardForm from '../forms/EditPcardForm';
import {useSearchParams } from 'react-router-dom';

const EditPcard = () => {
   const { t } = useTranslation();
   const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  return (
    <div className='add_card'>
      <h3 className='text-center m-3'> <FaIdCard/> {t("HEADING.ADDCARDTITLE")} </h3>
       <EditPcardForm translate={t} cardId={id} />
    </div>
  )
}

export default EditPcard
